/**
 * Il guscio: menu, schermata corrente, e la decisione se c'è una sessione.
 *
 * Sta fra il router e le schermate perché è il solo posto che deve conoscere
 * tutte e tre le cose — dove sei, chi sei, e cosa il tuo ruolo può aprire.
 */

import { Outlet, useNavigate, useRouterState } from '@tanstack/react-router';

import { MenuLaterale } from './components/side-menu';
import { schermataDa, schermatePermesse } from './screens/list';
import { Accesso, ConfermaIdentita } from './screens/sign-in';
import { useSessione } from '@errebi/sessione';

export function Guscio() {
  const { identita, esci } = useSessione();
  const navigate = useNavigate();
  const percorso = useRouterState({ select: (s) => s.location.pathname });

  if (!identita) {
    return (
      <>
        <Accesso />
        <ConfermaIdentita />
      </>
    );
  }

  const mie = schermatePermesse(identita.utente.ruoli);
  const corrente = schermataDa(percorso);

  return (
    <>
      <div className="telaio">
        <MenuLaterale
          voci={mie}
          corrente={corrente?.k}
          vai={(k) => {
            const s = mie.find((x) => x.k === k);
            if (s) void navigate({ to: s.percorso });
          }}
          utente={identita.utente.nome}
          esci={esci}
        />
        <div className="telaio__vista">
          <Outlet />
        </div>
      </div>
      <ConfermaIdentita />
    </>
  );
}

/**
 * Una schermata aperta per URL che il ruolo non può vedere.
 *
 * Il menu già non la mostra, ma l'URL si può digitare, incollare o tenere nei
 * preferiti da quando si aveva un altro ruolo. Meglio dirlo che mostrare una
 * pagina vuota: una schermata bianca sembra un guasto, e chi la vede chiama.
 */
export function NonPermessa({ nome }: { nome: string }) {
  const { identita } = useSessione();
  const navigate = useNavigate();
  const mie = schermatePermesse(identita?.utente.ruoli ?? []);

  return (
    <div className="centro">
      <div className="scheda">
        <h1 style={{ fontSize: 18, margin: '0 0 6px' }}>«{nome}» non è del tuo ruolo</h1>
        <p style={{ color: 'var(--ink2)', fontSize: 14, margin: '0 0 16px' }}>
          Il tuo ruolo è {(identita?.utente.ruoli ?? []).join(', ') || 'nessuno'}. Se ti serve
          questa schermata, chiedi a chi amministra gli utenti di aggiungerti il ruolo.
        </p>
        {mie[0] && (
          <button
            className="btn btn--primario"
            onClick={() => void navigate({ to: mie[0]!.percorso })}
          >
            Vai a {mie[0].nome}
          </button>
        )}
      </div>
    </div>
  );
}
